module.exports = __webpack_public_path__ + "static/FiestaEmpresa-5d36c054692115c8816cd617f7b7b146.jpg";